enum DistributorStatus {
  Active = "ACTIVE",
  Disabled = "DISABLED",
}

export default DistributorStatus;
